import { useEffect, useState } from 'react';
import arrow from '../assets/images/arrow.svg'
import arrow2 from '../assets/images/arrow2.svg'
import './TopButton.css'
function TopButton() {
    const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(window.pageYOffset > 0);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);
  return (
    <>
     {isVisible && (
      <div className='top-button' onClick={scrollToTop}>
        <img style={{height:"40px"}} src={arrow2} alt="" />
      </div>
     )}
    </>
  )
}

export default TopButton
